import React from 'react';
import { connect } from 'react-redux';
import { Heading2 } from '../../ui/Typography/Heading';
import { Button } from '../../ui';
import { IconCheck, IconArrowRight } from '../../ui/Icons';
import { updateConfigOnboardingSettings } from '../../../redux/config/slice';
import { OnboardingNavbar } from '../OnboardingNavbar/OnboardingNavbar';
import { selectUpdateConfigLoading } from '../../../redux/config/selectors';
import { ONBOARDING_STEPS } from '../../../consts/consts';
import {
  OnboardingContent,
  OnboardingHeaderGroup,
  OnboardingContentGroup,
  OnboardingContentTitle,
  OnboardingStepWrapper,
  OnboardingOverviewStageItem,
  OnboardingOverviewStageItemHeader,
  OnboardingOverviewStageTitleWrapper,
  OnboardingOverviewStageNumber,
  OnboardingOverviewStageContent,
  OnboardingOverviewStageTitle,
  OnboardingOverviewStageDescription,
  OnboardingOverviewStageAction,
  OnboardingOverviewStageCompletedLabel,
  OnboardingOverviewStageConnectionLineWrapper,
  OnboardingOverviewStageConnectionLine
} from '../../ui/Layout/OnboardingLayout';

export const OnboardingStepOverviewComponent = ({
  updateConfigOnboardingSettings,
  updateConfigLoading,
  currentStage
}) => {
  const handleStartStage = (stage) => {
    if (stage === 1) {
      updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.ORG_CREATE });
    } else if (stage === 2) {
      updateConfigOnboardingSettings({ step: ONBOARDING_STEPS.HOUSING_STOCK });
    }
  };

  const stages = [
    {
      number: 1,
      title: 'Eigenes Unternehmen',
      description:
        'Konfigurieren Sie Ihr Unternehmensprofil, um die Arbeit in oqio optimal vorzubereiten. Hier legen Sie Unternehmensangaben und Grund-Einstellungen für Ihre Nutzung fest.'
    },
    {
      number: 2,
      title: 'Bestand',
      description:
        'Erstellen Sie einen Bestand, um Ihre Objekte und beteiligten Unternehmen strukturiert zusammenzuführen. Dieser Schritt bildet die Basis für eine effiziente Zusammenarbeit in oqio.'
    }
  ];

  return (
    <>
      <OnboardingNavbar logoutLabel="Abmelden" loading={updateConfigLoading} />
      <OnboardingContent className="step-overview">
        <OnboardingStepWrapper>
          <OnboardingHeaderGroup className="no-border">
            <OnboardingContentTitle>
              <Heading2>Einführung in Ihr Versicherungsportal</Heading2>
            </OnboardingContentTitle>
          </OnboardingHeaderGroup>

          <OnboardingContentGroup className="step-overview content">
            {stages.map((stage) => {
              const isActive = currentStage >= stage.number;
              const isCompleted = currentStage > stage.number;
              const canStart = currentStage === stage.number;
              const showsConnectionLine = stage.number === 1;
              const isConnectionLineCompleted = currentStage === 2;

              return (
                <OnboardingOverviewStageItem key={stage.number}>
                  <OnboardingOverviewStageItemHeader>
                    <OnboardingOverviewStageTitleWrapper>
                      <OnboardingOverviewStageNumber active={isActive}>{stage.number}</OnboardingOverviewStageNumber>
                      <OnboardingOverviewStageTitle active={isActive}>{stage.title}</OnboardingOverviewStageTitle>
                    </OnboardingOverviewStageTitleWrapper>
                    <OnboardingOverviewStageAction>
                      {isCompleted ? (
                        <OnboardingOverviewStageCompletedLabel>
                          <IconCheck /> Abgeschlossen
                        </OnboardingOverviewStageCompletedLabel>
                      ) : (
                        <Button
                          type="link"
                          onClick={() => handleStartStage(stage.number)}
                          icon={<IconArrowRight />}
                          loading={canStart && updateConfigLoading}
                          disabled={!canStart}
                        >
                          Starten
                        </Button>
                      )}
                    </OnboardingOverviewStageAction>
                  </OnboardingOverviewStageItemHeader>

                  <OnboardingOverviewStageContent>
                    <OnboardingOverviewStageConnectionLineWrapper>
                      {showsConnectionLine && (
                        <OnboardingOverviewStageConnectionLine completed={isConnectionLineCompleted} />
                      )}
                    </OnboardingOverviewStageConnectionLineWrapper>
                    <OnboardingOverviewStageDescription active={isActive}>
                      {stage.description}
                    </OnboardingOverviewStageDescription>
                  </OnboardingOverviewStageContent>
                </OnboardingOverviewStageItem>
              );
            })}
          </OnboardingContentGroup>
        </OnboardingStepWrapper>
      </OnboardingContent>
    </>
  );
};

const mapStateToProps = (state) => ({
  updateConfigLoading: selectUpdateConfigLoading(state)
});

const mapDispatchToProps = {
  updateConfigOnboardingSettings
};

export const OnboardingStepOverview = connect(mapStateToProps, mapDispatchToProps)(OnboardingStepOverviewComponent);
